import { useEffect, useState } from "react";
import { useMessaging } from "./api";

/** The clock, a second at a time while `active`, so a code's countdown moves. */
function useSeconds(active: boolean): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    const tick = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(tick);
  }, [active]);
  return now;
}

/**
 * The server's clock, a second at a time while `active`: this device's plus
 * the skew `GET /api/messaging` measured, so a code's countdown and expiry
 * hold however wrong the device's clock is (as Integrations' sign-ins do).
 */
export function useServerSeconds(active: boolean): number {
  const skew = useMessaging().data?.skew ?? 0;
  return useSeconds(active) + skew;
}
